import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { H1 } from '../../components/';
import { ImportLegacyAccount } from '../../migrate/importLegacyAccount/';
import ImportLegacySuccess from './ImportAccountSuccess';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { migrateAdditionalAccount, resetUserValidation } from '../../migrate/actions';
import { userValidation } from '../../migrate/reducer';
import { getUserData } from '../../user/selectors';

import { userTypes } from '../../types/user';

export const ImportAccountContent = ({ migrateAdditionalAccount, userValidation, resetUserValidation, user }) => (
  <div className='ta-sm-c pt5-lg pb5-lg profile__edit_email'>
    {!userValidation && (
      <>
        <H1 className='mb7-sm'>
          <TranslatedCopy id='profile.import.title' />
        </H1>
        <div className='body-4 text-color-secondary mb3-sm ta-c-sm'>
          <TranslatedCopy id='profile.import.copy' />
        </div>
        <ImportLegacyAccount importSubmit={migrateAdditionalAccount} type='modal' />
      </>
    )}
    {userValidation && (
      <ImportLegacySuccess userValidation={userValidation} resetUserValidation={resetUserValidation} user={user} />
    )}
  </div>
);

ImportAccountContent.defaultProps = {
  userValidation: null,
  user: null
};

ImportAccountContent.propTypes = {
  userValidation: PropTypes.any,
  migrateAdditionalAccount: PropTypes.func.isRequired,
  resetUserValidation: PropTypes.func.isRequired,
  user: userTypes
};

const mapStateToProps = state => ({
  userValidation: userValidation(state),
  user: getUserData(state)
});

const connector = connect(mapStateToProps, {
  migrateAdditionalAccount,
  resetUserValidation
});

export default connector(ImportAccountContent);
